import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, msalInstance } from './app/app.config';
import { App } from './app/app';
import { defineCustomElements } from '@scania/tegel/loader';

async function booststrap() {
  defineCustomElements(window);

  await msalInstance.initialize();
  const response = await msalInstance.handleRedirectPromise();

  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}

booststrap();
